import MaterialMenuItem, { MenuItemProps } from '@mui/material/MenuItem';

export function MenuItem(props: MenuItemProps) {
    return <MaterialMenuItem data-testid={'MenuItem-container'} {...props} />;
}

export default MenuItem;
